import { GitCommit } from "lucide-react";
import { useSelector } from "react-redux";

const GitCommitText = () => {
  const naruhoneData = useSelector((state) => state.dashboard.naruhone);

  return (
    <>
      {naruhoneData && (
        <div>
          <div className="flex">
            <code className="text-blue-500 font-mono mr-2 m-0">main</code>
            <div className="w-4 mr-2">
              <GitCommit className="text-blue-500" />
            </div>

            <code className="font-mono text-slate-200 ml-2 m-0">
              {naruhoneData.gitstats.maincommit}
            </code>
          </div>
          <div className="flex">
            <code className="text-green-500 font-mono mr-4 m-0">dev</code>
            <div className="w-4 mr-2">
              <GitCommit className="text-green-500" />
            </div>
            <code className="font-mono text-slate-200 ml-2 m-0">
              {naruhoneData.gitstats.devcommit}
            </code>
          </div>
        </div>
      )}
    </>
  );
};

export default GitCommitText;
